import Vue from 'vue'

/* @mousemove="animateBackground($event)" */
let backgroundFollow = {
    data() {
        return {
            offset: 50,
            height: null,
            newX: null,
            newY: null,
            width: null,
            backgroundPosition: 'center'
        }
    },
    mounted() {
        this.height = this.offset / window.innerHeight
        this.width = this.offset / window.innerWidth
    },
    methods: {
        animateBackground(e) {
            var pageX = e.pageX - (window.innerWidth / 2)
            var pageY = e.pageY - (window.innerHeight / 2);
            this.newX = this.width * pageX * -1 - 25;
            this.newY = this.height * pageY * -1 - 50;
            this.backgroundPosition = `${this.newX}px ${this.newY}px`;
        },
        setBackground(bg) {
            return {
                backgroundPosition: `${this.newX}px ${this.newY}px`,
                backgroundImage: `url(${bg})`
            }
        }
    }
}

export default backgroundFollow